/**
 * Projection calculation functions
 */

interface CycleProjection {
  annual: number;
  monthly: number;
}

interface AnnualProjections {
  cycles5: CycleProjection;
  cycles55: CycleProjection;
  cycles6: CycleProjection;
}

/**
 * Calculate annual projections for different cycle frequencies
 * 
 * @param netProfit - Net profit per cycle
 * @returns Object with projections for 5, 5.5, and 6 cycles per year
 */
export function calculateAnnualProjections(netProfit: number): AnnualProjections {
  const cycles5Annual = netProfit * 5;
  const cycles55Annual = netProfit * 5.5;
  const cycles6Annual = netProfit * 6;
  
  return {
    cycles5: {
      annual: cycles5Annual,
      monthly: cycles5Annual / 12,
    },
    cycles55: {
      annual: cycles55Annual,
      monthly: cycles55Annual / 12,
    },
    cycles6: {
      annual: cycles6Annual,
      monthly: cycles6Annual / 12,
    },
  };
}
